import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { ECoachBreadcrumbVariant as EVariant } from "./coach.breadcrumbs.types"

export default {
    container: ({ isReady }: { isReady: boolean }): string =>
        buildCssClassName(
            "w-full max-[767px]:px-[15px] max-[767px]:py-[10px]",
            { "blur-[5px] opacity-50 [pointer-events:none]": !isReady },
            { "blur-0 opacity-100": isReady },
            getTransitionTwClasses("all", 200)
        ),
    wrapper: (): string => "w-full overflow-x-auto no-scrollbar flex items-baseline md:items-center",
    item: (): string => "flex items-baseline",
    itemLabel: ({ isActive, variant }: { isActive: boolean; variant: EVariant }): string =>
        buildCssClassName(
            "block",
            "md:flex",
            "md:gap-x-[5px]",
            "md:items-baseline",
            "border-b-[1px]",
            "px-[5px]",
            "bg-white",
            "line-clamp-1",
            "!outline-none",
            "text-[14px]",
            "leading-[21px]",
            "font-[300]",
            { "text-gray-100": isActive },
            { "text-gray-200": !isActive },
            { "hover:text-gray-100 focus-visible:text-gray-100": true },
            variant === EVariant.Dashboard && [
                {
                    "pb-[4px]": true,
                    "border-b-accent": isActive,
                    "border-b-transparent hover:border-b-blue-200 focus-visible:border-b-blue-200": !isActive
                }
            ],
            variant === EVariant.Individual && [
                {
                    "pb-[4px]": true,
                    "border-b-accent": isActive,
                    "border-b-transparent hover:border-b-blue-200 focus-visible:border-b-blue-200": !isActive,
                    "truncate max-[767px]:max-w-[100px]": true
                }
            ],
            variant === EVariant.Group && [
                {
                    "pb-[8px] md:pb-[4px]": true,
                    "border-b-blue-400 md:border-b-accent": isActive,
                    "border-b-transparent hover:border-b-blue-200 focus-visible:border-b-blue-200": !isActive,
                    "truncate max-[767px]:max-w-[100px]": true
                }
            ],
            getTransitionTwClasses("all", 200)
        ),
    arrow: (): string => "mx-[5px] top-[2px] relative"
}
